import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Nav = styled.nav`
  background: ${({ theme }) => theme.colors.background};
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem calc((100vw - 1200px) / 2);
  z-index: 10;
  position: sticky;
  top: 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const Logo = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 1.8rem;
  font-weight: bold;
  padding: 0 1rem;
`;

export const MenuItems = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
    flex-direction: column;
    width: 100%;
    height: 90vh;
    position: absolute;
    top: 80px;
    left: 0;
    background: ${({ theme }) => theme.colors.background};
    padding: 2rem 0;
  }
`;

export const MenuItem = styled.li`
  padding: 0 1rem;

  a {
    color: ${({ theme }) => theme.colors.text};
    font-weight: 500;
    transition: color 0.3s ease;

    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 1rem 0;
  }
`;

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: block;
    position: absolute;
    right: 1rem;
    font-size: 1.8rem;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.primary};
  }
`;